export const data = function () {
  return {
    dialogIndicadores: false,
    page: {
      title: 'Relatório de Pedidos',
    },
    breadcrumbs: [
      {
        text: 'Relatórios',
        disabled: false,
      },
      {
        text: 'Relatório de Pedidos',
        disabled: false,
      },
    ],
  }
}
